import _typeof from "./typeof.js";
import toPrimitive from "./toPrimitive.js";
//#region ../erd-editor-schema/dist/_virtual/_@oxc-project_runtime@0.151.0/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
//#endregion
export { toPropertyKey as default };
